// extracted by mini-css-extract-plugin
export default {"sectionTabs":"StudentNotesModalTabs_sectionTabs__alKSL","tabs":"StudentNotesModalTabs_tabs__Xz0OG","panel":"StudentNotesModalTabs_panel__QwNGp"};